<template>
  <div>
    <div class="col-12 lg:col-12 px-0">
      <Toolbar class="mb-2">
        <template #end>
          <Button
            label="Nuevo"
            icon="pi pi-plus"
            class="p-button-success mr-2"
            @Click="nuevoConsumible"
          />
        </template>
      </Toolbar>
    </div>
    <DataTable
      :value="lstExistencias"
      datakey="id_existencias"
      scrollDirection="both"
      :filters="filters"
      :scrollable="true"
      :globalFilterFields="[]"
    >
      <template #header>
        <div class="p-grid flex justify-content-between">
          <h5>Consumibles y Existencias</h5>
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              type="text"
              v-model="filters['global'].value"
              placeholder="Buscar..."
            />
          </span>
        </div>
      </template>
      <template #empty> No se encontrarón registros. </template>
      <template #loading> Cargando los datos. Espere por favor... </template>

      <Column header="Acciones" style="width: 150px">
        <template #body="slotProps">
          <Button
            icon="pi pi-plus"
            severity="success"
            rounded
            outlined
            class="mr-2"
            v-tooltip.top="'Agregar Existencia'"
            @click="abrirMovimiento(slotProps.data, 'entrada')"
          />

          <Button
            icon="pi pi-minus"
            severity="warning"
            rounded
            outlined
            class="mr-2"
            v-tooltip.top="'Retirar Existencia'"
            @click="abrirMovimiento(slotProps.data, 'salida')"
          />

          <Button
            icon="pi pi-trash"
            severity="danger"
            text
            rounded
            v-tooltip.top="'Eliminar del catálogo'"
            @click="eliminarConsumible(slotProps.data)"
          />
        </template>
      </Column>

      <Column
        field="Consumible"
        header="Consumible"
        sortable
        style="width: 180px"
      ></Column>
      <Column
        field="Existencia"
        header="Existencia"
        sortable
        style="width: 180px"
      >
        <template #body="slotProps">
          <Tag
            :value="slotProps.data.Existencia"
            :severity="getSeverity(slotProps.data.Existencia)"
            rounded
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      :style="{ width: '450px' }"
      :visible="showDialog"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
        <h3>{{ tituloDialogo }}</h3>
      </template>
      <div class="field">
        <div v-if="objConsumible.esNuevo"
        style="margin-bottom: 2rem;">
          <label for="Consumible"> Nombre del consumible </label>
          <inputText
            id="ConsumibleNuevo"
            v-model="objConsumible.Consumible"
            autofocus
          />
        </div>
        <div v-else class="mb-3">
          <span style="font-weight: bold"
            >Existencia actual: {{ objConsumible.StockActual }}
          </span>
        </div>

        <label for="cantidad"
          >¿Qué cantidad vas a
          {{ objConsumible.esEntrada ? "agregar" : "retirar" }}?</label
        >
        <InputNumber
          id="cantidad"
          v-model="objConsumible.Existencia"
          :min="1"
          showButtons
          buttonLayout="horizontal"
          :inputStyle="{ textAlign: 'center', width: '4rem' }"
          style="width: 12rem; margin-left: 1rem"
          required="true"
          autofocus
        />

        <small style="color: red; display:block;" v-if="submitted && !objConsumible.Existencia">
          Debes ingresar una cantidad.
        </small>
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogo"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarMovimiento"
        />
      </template>
    </Dialog>
  </div>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import SrvrEx from "../service/Existencias";
import { ConfirmDialog } from "primevue/confirmdialog";
export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      lstExistencias: [],
      objConsumible: {
        Id_tipo_consumible: null,
        Consumible: null,
        Existencia: null,
        esNuevo: null,
        esEntrada: null,
        esSalida: null,
      },
      loading: false,
      showDialog: false,
      submitted: false,
    };
  },
  created() {},
  mounted() {
    var t = this;
    t.cargaInicial();
  },
  methods: {
    cargaInicial() {
      var t = this;
      var ctlSvr = new SrvrEx();
      t.loading = true;
      ctlSvr.getAll(t).then((res) => {
        t.lstExistencias = res;
        t.loading = false;
      });
    },
    nuevoMovimiento() {
      var t = this;
      t.objConsumible = {
        esNuevo: false,
      };
      t.showDialog = true;
      t.submitted = false;
    },
    nuevoConsumible() {
      var t = this;
      t.objConsumible = {
        esNuevo: true,
        esEntrada: true,
        esSalida: false,
        Consumible: "",
        Existencia: null,
      };

      t.tituloDialogo = "Nuevo Consumible";
      t.showDialog = true;
      t.submitted = false;
    },
    cancelarDialogo() {
      var t = this;
      t.objConsumible = {
        Id_tipo_consumible: null,
        Consumible: null,
        Existencia: null,
        esNuevo: null,
        esEntrada: null,
        esSalida: null,
      };
      t.showDialog = false;
      t.submitted = false;
    },
    guardarMovimiento() {
      var t = this;
      t.submitted = true; 

      if (!t.objConsumible.Existencia || t.objConsumible.Existencia <= 0) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debes ingresar una cantidad válida mayor a 0.",
          life: 3000,
        });
        return; 
      }

      if(t.objConsumible.esNuevo && !t.objConsumible.Consumible) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debes escribir el nombre del consumible.",
          life: 3000,
        });
        return
      }

      const ctlSvr = new SrvrEx();
      if (t.objConsumible.esNuevo) {
        ctlSvr.Add(t, t.objConsumible).then(() => {
          console.log("objeto nuevo", t.objConsumible);
          this.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Directorio actualizado correctamente",
            life: 3000,
          });
          this.cancelarDialogo();
          this.cargaInicial();
        });
      } else if (t.objConsumible.esEntrada) {
        ctlSvr.Agregar(t, t.objConsumible).then(() => {
          console.log("objeto entrada", t.objConsumible);
          this.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Directorio actualizado correctamente",
            life: 3000,
          });
          this.cancelarDialogo();
          this.cargaInicial();
        });
      } else if (t.objConsumible.esSalida) {
        ctlSvr.Restar(t, t.objConsumible).then(() => {
          console.log("objeto salida", t.objConsumible);
          this.$toast.add({
            severity: "success",
            summary: "AVISO",
            detail: "Directorio actualizado correctamente",
            life: 3000,
          });
          this.cancelarDialogo();
          this.cargaInicial();
        });
      }
    },
    eliminarConsumible(obj) {
      var t = this;
      t.$confirm.require({
        message: "¿Quiere eliminar el catalogo?",
        header: "Confirmacion",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, eliminar",
        rejectLabel: "Cancelar",
        acceptClass: "p-button-danger",
        accept: () => {
          const ctlSvr = new SrvrEx();
          ctlSvr.Delete(t, obj.Id_tipo_consumible).then(() => {
            this.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Directorio actualizado correctamente",
              life: 3000,
            });
            this.cancelarDialogo();
            this.cargaInicial();
          });
        },
        reject: () => {},
      });
    },
    abrirMovimiento(item, tipo) {
      var t = this;
      t.objConsumible = { ...item };
      console.log("objeto seleccionado: ", item);

      t.objConsumible.esNuevo = false;
      t.objConsumible.Existencia = null;
      t.objConsumible.StockActual = item.Existencia;

      if (tipo === "entrada") {
        t.objConsumible.esEntrada = true;
        t.objConsumible.esSalida = false;
        t.tituloDialogo = "Agregar Stock: " + item.Consumible;
      } else {
        t.objConsumible.esEntrada = false;
        t.objConsumible.esSalida = true;
        t.tituloDialogo = "Retirar Stock: " + item.Consumible;
      }
      t.showDialog = true;
      t.submitted = false;
    },
    getSeverity(cantidad) {
      if (cantidad < 5) return "danger"; // Rojo (Poco stock o negativo)
      if (cantidad < 15) return "warning"; // Amarillo (Alerta)
      return "success"; // Verde (Todo bien)
    },
  },
};
</script>

<style scoped></style>
